// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__28FVK","spin":"Spinner_spin__ul+vj","medium":"Spinner_medium__7YQkF","large":"Spinner_large__4gzMR"};